let dotNetInstance;

function debounce(func, wait) {
    let timeout;
    return function (...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function (...args) {
        const context = this;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function () {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}

function onInputDebounced(event) {
    dotNetInstance?.reference?.invokeMethodAsync("OnInputDebounced", event?.value);
}

function onInputThrottled(event) {
    dotNetInstance?.reference?.invokeMethodAsync("OnInputThrottled", event?.value);
}

window.Timing = {
    setup: function(dotNetObj) {
        dotNetInstance = dotNetObj;
    },
    debouncedInput: function(delay, event) {
        debounce(() => onInputDebounced(event), delay);
    },
    throttledInput: function(delay, event) {
        throttle(() => onInputThrottled(event), delay);
    }
}